// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","593":"fail"}[chunkId] + "." + {"443":"6d7213cd","593":"c1d98f5a"}[chunkId] + ".css";
};